import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Package, Mail } from 'lucide-react';

const CheckoutSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 pt-20 pb-12">
      <div className="max-w-2xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-sm p-8 text-center">
          <div className="mb-6">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
              <CheckCircle className="w-10 h-10 text-green-600" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Payment Successful!
            </h1>
            <p className="text-gray-600 text-lg">
              Thank you for your purchase from BX KICKS
            </p>
          </div>

          <div className="border-t border-b border-gray-200 py-6 my-6">
            <div className="space-y-4">
              <div className="flex items-start justify-center text-left">
                <Mail className="w-5 h-5 text-brand-purple mr-3 mt-0.5" />
                <div>
                  <p className="font-medium text-gray-900">Order Confirmation Sent</p>
                  <p className="text-sm text-gray-600">
                    We've sent a confirmation email with your order details and tracking information.
                  </p>
                </div>
              </div>

              <div className="flex items-start justify-center text-left">
                <Package className="w-5 h-5 text-brand-purple mr-3 mt-0.5" />
                <div>
                  <p className="font-medium text-gray-900">Processing Your Order</p>
                  <p className="text-sm text-gray-600">
                    Your order is being processed and will ship within 1-2 business days.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <button
              onClick={() => navigate('/collection')}
              className="w-full bg-brand-purple text-white px-6 py-3 rounded-lg hover:bg-purple-700 transition-colors"
            >
              Continue Shopping
            </button>
            <button
              onClick={() => navigate('/')}
              className="w-full border border-gray-300 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Back to Home
            </button>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              Need help? Contact us at{' '}
              <a href="mailto:support@bxkicks.com" className="text-brand-purple hover:underline">
                support@bxkicks.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccess;
